export default __webpack_public_path__ + "static/media/bg6.60d1576e.jpg";